import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import PipelineView from './PipelineView';

const route: FuseRouteItemType = {
	path: 'catalog/pipeline',
	element: <PipelineView />
};

export default route;
